<template>
  <fieldset>
    <select :name="name" v-model="selected" class="form-control" data-role="select" :data-filter="filter ? 'true' : 'false'"
      :required="required" id="type">
      <option value="null">
        {{
          placeholder | trans
        }}</option>
      <option v-for="(breed, index) in data" :value="index">{{ breed }}</option>
    </select>
    <label class="form-control-placeholder" for="type">{{
      'javascript.horse_registration.breed_association' | trans
    }}</label>
  </fieldset>
</template>

<script>
export default {
  props: {
    data: [Array, Object],
    required: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Boolean,
      default: false
    },
    name: String,
    placeholder: String,
    id: String,
    value: [String, Number]
  },

  data: () => ({
    selected: '',
    oldValue: null
  }),

  created() {
    if (!Object.keys(this.data).includes(this.value.toString())) {
      this.oldValue = this.value
      this.selected = 'null'
    } else {
      this.selected = this.value
    }
  },

  watch: {
    selected(val, old) {
      if (this.selected === 'null' && this.oldValue !== null) {
        this.$emit('input', this.oldValue)
      } else {
        this.oldValue = null
        this.$emit('input', val)
      }
    },
    value(val, old) {
      if (!Object.keys(this.data).includes(val.toString())) {
        this.oldValue = this.selected
        this.selected = 'null'
      }
    }
  }
}
</script>
